import { render, staticRenderFns } from "./keywords-add-or-update.vue?vue&type=template&id=c2a97b36&"
import script from "./keywords-add-or-update.vue?vue&type=script&lang=js&"
export * from "./keywords-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports